"use client"

import { useContext } from "react";
import Link from "next/link";

import { motion } from "framer-motion";

import MarkdownRenderer from "@/components/markdownRenderer"
import { Accordion, AccordionItem, Button, Card } from "@heroui/react";
import { BsStars } from "react-icons/bs";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";

import { faq } from "@/app/data/faq"
import { CountdownContext } from "@/lib/CountdownContext";

export default function Audition({ content }: { content: string }) {
    const { hasFinished } = useContext(CountdownContext);

    return (
        <>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6 }}
            >
                {/* Audition Info */}
                <section id="audition" className="scroll-mt-24 md:scroll-mt-36">
                    <h2 className="second-header">AUDITION INFORMATION</h2>
                    <Card className="backdrop-blur-2xl bg-transparent mx-auto px-10 pb-10 mt-10 max-w-4xl outline-2 outline-black purple-glow">
                        <MarkdownRenderer content={content} />
                        {!hasFinished && (
                            <>
                                <p className="text-white text-center">Excited to build a community around your favourite games?</p>
                                <div className="flex justify-center">
                                    <IoIosArrowForward color="white" size={56} />
                                    <Button
                                        className="w-1/2 self-center mx-12 hover:mx-4 bg-primary-800 hover:outline-2 hover:outline-white outline-offset-2 transition-all ease-in-out text-white"
                                        as={Link}
                                        href="https://docs.google.com/forms/d/e/1FAIpQLSe0HY54xtPhDt3RNkATwmd5WwdChvYwts5wqkszUKfKYnHbVA/viewform"
                                        target="_blank"
                                        disableRipple
                                        size="lg"
                                        color="primary"
                                    >
                                        Apply Now!
                                    </Button>
                                    <IoIosArrowBack color="white" size={56} />
                                </div>
                            </>
                        )}
                    </Card>
                </section>

                {/* FAQ */}
                <section id="faq" className="scroll-mt-24 md:scroll-mt-36">
                    <Card
                        className="backdrop-blur-2xl bg-transparent mx-auto px-10 pb-10 mt-10 max-w-4xl outline-2 outline-black purple-glow"
                    >
                        <h2 className="second-header py-10">Frequently Asked Questions</h2>
                        <Accordion
                            className="text-white"
                            selectionMode="multiple"
                            dividerProps={{ className: "bg-gray-400" }}
                            hideIndicator
                        >
                            {faq.map((val, idx) => (
                                <AccordionItem
                                    key={idx}
                                    aria-label={val.question}
                                    title={val.question}
                                    classNames={{
                                        title: "text-white font-bold text-lg cursor-pointer"
                                    }}
                                    startContent={(<BsStars />)}
                                >
                                    <p className="pb-4">{val.answer}</p>
                                </AccordionItem>
                            ))}
                        </Accordion>
                        <p className="text-gray-400 text-center pt-10">Still got questions? <a className="text-blue-400" href="#contact">Contact us</a></p>
                    </Card>
                </section>
            </motion.div>
        </>
    )
}